export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8920.4ec0eac8.jpg";